import React from "react";
import { Button, Modal } from "react-bootstrap";
import NewClientModal from "../modals/NewClientModal";
import ClientUpdateModal from "../modals/ClientUpdateModal";
import ClientsList from "./clientsPage/ClientsList";
import DeleteClientModal from "./clientsPage/DeleteClientModal";
import useClientsPageController from "./clientsPage/useClientsPageController";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function ClientsPage() {
  const {
    t,
    clients,
    loading,
    showNewClient,
    showClientUpdateModal,
    showDeleteConfirmation,
    clientIdToModify,
    openNewClient,
    closeNewClient,
    handleRowClick,
    handleModifyClient,
    handleClientUpdateClose,
    handleClientUpdate,
    handleDeleteClient,
    handleConfirmDelete,
    handleCancelDelete
  } = useClientsPageController();

  return (
    <div className="container d-xl-block">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1>{t("clientsTitle")}</h1>
        <Button variant="secondary" className="me-2" onClick={openNewClient}>
          {t("addClient")}
        </Button>
      </div>

      <ClientsList clients={clients} t={t} loading={loading}
        onRowClick={handleRowClick} onModify={handleModifyClient} onDelete={handleDeleteClient} />

      <Modal show={showNewClient} onHide={closeNewClient}>
        <Modal.Header closeButton>
          <Modal.Title>{t("addClientTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewClientModal onClose={closeNewClient} />
        </Modal.Body>
      </Modal>

      <Modal show={showClientUpdateModal} onHide={handleClientUpdateClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("editClientTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ClientUpdateModal
            handleClose={handleClientUpdateClose}
            clientId={clientIdToModify}
            onUpdate={handleClientUpdate}
          />
        </Modal.Body>
      </Modal>

      <DeleteClientModal
        show={showDeleteConfirmation}
        t={t}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
}
